export function getFileName(url: string, extension: string, keepExtension: boolean = false): string {
  extension = extension[0] === '.' ? extension : `.${extension}`;

  const [fileName] = url.split('/').slice(-1);

  return keepExtension ? fileName : fileName.replace(`${extension}`, '');
}
